export function getLnatTopicEndReviewCopy(section) {
  const key = String(section || '').toLowerCase();
  if (key === 'lsat') {
    return 'You will not be able to return to this LSAT practice. Are you sure you want to continue?';
  }
  if (key === 'b' || key === 'section_b') {
    return 'You will not be able to return to this Section B practice. Are you sure you want to continue?';
  }
  return 'You will not be able to return to this Section A practice. Are you sure you want to continue?';
}

export function isLnatEssayReviewPhase({ isLnatExam, isTopicDrill, tmuaPaperPhase } = {}) {
  return Boolean(
    (isLnatExam && isTopicDrill && tmuaPaperPhase === 'p1_review')
    || tmuaPaperPhase === 'p2_review'
  );
}

export function pickLnatEssayReviewList({
  isLnatExam,
  isTopicDrill,
  tmuaPaperPhase,
  paper1Qs,
  paper2Qs,
  takingQuestions,
} = {}) {
  if (isLnatExam && isTopicDrill && tmuaPaperPhase === 'p1_review') {
    return paper1Qs || takingQuestions;
  }
  return paper2Qs;
}

export function isLnatTopicSectionB({ isTopicDrill, lnatSection } = {}) {
  const key = String(lnatSection || '').toLowerCase();
  return Boolean(isTopicDrill && (key === 'b' || key === 'section_b'));
}

/** Topic-drill Section B uses paper1Qs; mock B uses paper2Qs. */
export function pickLnatOneResponseQuestionList({
  isTopicDrill,
  lnatSection,
  paper1Qs,
  paper2Qs,
  takingQuestions,
} = {}) {
  if (isLnatTopicSectionB({ isTopicDrill, lnatSection })) {
    return paper1Qs || takingQuestions || [];
  }
  return paper2Qs || [];
}
